module.exports = __webpack_public_path__ + "img/punch-w.8ed4fde3.png";